/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Virtual Job Experience
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

import store from '@/store/store';

const getters = {
  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: (state) => {
    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return 'xl';
    else if (state.windowWidth >= 992) return 'lg';
    else if (state.windowWidth >= 768) return 'md';
    else if (state.windowWidth >= 576) return 'sm';
    else return 'xs';
  },

  scrollbarTag: (state) => {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar';
  },

  experiencePopupVideoUrl: (state) => {
    return state.experiencePopupVideoUrl;
  },

  // eslint-disable-next-line no-unused-vars
  logoUrl: (state) => {
    const login_type = localStorage.getItem('login_type');
    if (login_type == 'teacher') return store.getters['authTeacher/logo'];
    if (login_type == 'student') return store.getters['authStudent/logo'];
    return false;
  },
  theToken() {
    const login_type = localStorage.getItem('login_type');
    if (login_type === 'teacher') {
      return store.getters['authTeacher/token'];
    } else if (login_type === 'student') {
      return store.getters['authStudent/token'];
    }
  },
  theApiUrl() {
    const login_type = localStorage.getItem('login_type');
    return $vjeConfig.VUE_APP_API_URL + login_type + '/';
  },
  isActiveApiCall: (state) => {
    return state.isActiveApiCall;
  },
};

export default getters;
